module.exports = __webpack_public_path__ + "static/media/BAJAJFINSV_F1.94a634fb.txt";